"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var index_exports = {};
__export(index_exports, {
  createSheet: () => createSheet,
  cx: () => cx
});
module.exports = __toCommonJS(index_exports);

// src/shorthands.ts
var longhands = {
  margin: [
    "margin-top",
    "margin-right",
    "margin-bottom",
    "margin-left",
    "margin-inline-start",
    "margin-inline-end",
    "margin-block-start",
    "margin-block-end"
  ],
  padding: [
    "padding-top",
    "padding-right",
    "padding-bottom",
    "padding-left",
    "padding-inline-start",
    "padding-inline-end",
    "padding-block-start",
    "padding-block-end"
  ],
  inset: ["top", "right", "bottom", "left"],
  gap: ["row-gap", "column-gap"],
  overflow: ["overflow-x", "overflow-y"],
  "border-width": [
    "border-top-width",
    "border-right-width",
    "border-bottom-width",
    "border-left-width"
  ],
  "border-style": [
    "border-top-style",
    "border-right-style",
    "border-bottom-style",
    "border-left-style"
  ],
  "border-color": [
    "border-top-color",
    "border-right-color",
    "border-bottom-color",
    "border-left-color"
  ],
  "border-top": ["border-top-width", "border-top-style", "border-top-color"],
  "border-right": [
    "border-right-width",
    "border-right-style",
    "border-right-color"
  ],
  "border-bottom": [
    "border-bottom-width",
    "border-bottom-style",
    "border-bottom-color"
  ],
  "border-left": [
    "border-left-width",
    "border-left-style",
    "border-left-color"
  ],
  border: [
    "border-width",
    "border-style",
    "border-color",
    "border-top-width",
    "border-top-style",
    "border-top-color",
    "border-right-width",
    "border-right-style",
    "border-right-color",
    "border-bottom-width",
    "border-bottom-style",
    "border-bottom-color",
    "border-left-width",
    "border-left-style",
    "border-left-color",
    "border-image",
    "border-image-source",
    "border-image-slice",
    "border-image-width",
    "border-image-outset",
    "border-image-repeat"
  ],
  "border-radius": [
    "border-top-left-radius",
    "border-top-right-radius",
    "border-bottom-right-radius",
    "border-bottom-left-radius"
  ],
  outline: ["outline-width", "outline-style", "outline-color"],
  background: [
    "background-color",
    "background-image",
    "background-position",
    "background-size",
    "background-repeat",
    "background-attachment",
    "background-origin",
    "background-clip"
  ],
  font: [
    "font-style",
    "font-variant",
    "font-weight",
    "font-size",
    "font-family",
    "line-height"
  ],
  flex: ["flex-grow", "flex-shrink", "flex-basis"],
  "text-decoration": [
    "text-decoration-line",
    "text-decoration-style",
    "text-decoration-color",
    "text-decoration-thickness"
  ]
};
function coveredProperties(property) {
  const covered = longhands[property];
  if (covered) {
    return [property].concat(covered);
  }
  return [property];
}
var distributiveKinds = {
  margin: "box",
  padding: "box",
  inset: "box",
  "border-width": "box",
  "border-style": "box",
  "border-color": "box",
  gap: "pair",
  overflow: "pair",
  "border-radius": "corners"
};
function distributiveExpansion(property) {
  const kind = distributiveKinds[property];
  const covered = kind ? longhands[property] : void 0;
  if (!kind || !covered) {
    return void 0;
  }
  return { kind, longhands: covered };
}

// src/utils/asArray.ts
function asArray(v) {
  return [].concat(v);
}

// src/utils/is.ts
function isPsuedoSelector(selector) {
  return selector.startsWith(":");
}
function isStyleCondition(selector) {
  return isString(selector) && (selector === "*" || selector.length > 1 && ":>~.+*".includes(selector.slice(0, 1)) || isImmediatePostcondition(selector));
}
function isValidProperty(property, value) {
  return (isString(value) || typeof value === "number") && !isCssVariables(property) && !isPsuedoSelector(property) && !isMediaQuery(property);
}
function isMediaQuery(selector) {
  return selector.startsWith("@media");
}
function isKeyframes(selector) {
  return selector.startsWith("@keyframes");
}
function isDirectClass(selector) {
  return selector === ".";
}
function isCssVariables(selector) {
  return selector === "--";
}
function isString(value) {
  return value + "" === value;
}
function isImmediatePostcondition(value) {
  return isString(value) && (value.startsWith("&") || isPsuedoSelector(value));
}

// src/utils/joinTruthy.ts
function joinTruthy(arr, delimiter = "") {
  return arr.filter(Boolean).join(delimiter);
}

// src/utils/stableHash.ts
function stableHash(prefix, seed) {
  let hash = 0;
  if (seed.length === 0) return hash.toString();
  for (let i = 0; i < seed.length; i++) {
    const char = seed.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash;
  }
  return `${prefix ?? "cl"}_${hash.toString(36)}`;
}

// src/utils/stringManipulators.ts
function handlePropertyValue(property, value) {
  if (property === "content") {
    return `"${value}"`;
  }
  return value;
}
function camelCaseToDash(str) {
  return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function joinedProperty(property, value) {
  return `${property}:${value}`;
}
function toClass(str) {
  return str ? `.${str}` : "";
}
function appendString(base, line) {
  return appendStringInline(base, line, "\n");
}
function appendStringInline(base, line, separator = " ") {
  return base ? `${base}${separator}${line}` : line;
}

// src/Rule.ts
function toCssIdent(value) {
  const cleaned = value.replace(/[^a-zA-Z0-9_-]/g, "_");
  if (/^[0-9]/.test(cleaned) || /^-[0-9]/.test(cleaned)) {
    return `_${cleaned}`;
  }
  return cleaned;
}
function sheetIdent(name) {
  const encoded = name.replace(
    /[^A-Za-z0-9-]/g,
    (char) => `_${char.charCodeAt(0).toString(16)}_`
  );
  if (/^[0-9]/.test(encoded) || /^-[0-9]/.test(encoded)) {
    return `_${encoded}`;
  }
  return encoded;
}
var Rule = class _Rule {
  constructor(sheet, property, value, selector) {
    this.sheet = sheet;
    this.property = property;
    this.value = value;
    this.selector = selector;
    this.property = property;
    this.value = value;
    this.joined = joinedProperty(camelCaseToDash(property), value);
    const pre = this.selector.preconditions.join("\0");
    const post = this.selector.postconditions.join("\0");
    const atKey = this.selector.atRules.join("|");
    const scopePart = this.selector.hasConditions ? this.selector.scopeClassName : "";
    this.key = [this.joined, pre, post, atKey, scopePart].join("\0");
    this.hash = this.buildHash(atKey);
  }
  getConflictKeys() {
    const pre = this.selector.preconditions.join(",");
    const post = this.selector.postconditions.join(",");
    const at = this.selector.atRules.join("|");
    return coveredProperties(camelCaseToDash(this.property)).map(
      (prop) => [prop, pre, post, at].join("\0")
    );
  }
  buildHash(atKey) {
    if (!this.selector.hasConditions && !atKey) {
      return stableHash(sheetIdent(this.sheet.name), this.joined);
    }
    return stableHash(sheetIdent(this.sheet.name), this.key);
  }
  toString() {
    let selectors = mergeSelectors(this.selector.preconditions, {
      right: this.hash
    });
    selectors = mergeSelectors(this.selector.postconditions, {
      left: selectors
    });
    return `${selectors} {${_Rule.genRule(this.property, this.value)}}`;
  }
  static genRule(property, value) {
    const transformedProperty = camelCaseToDash(property);
    return joinedProperty(
      transformedProperty,
      handlePropertyValue(property, value)
    ) + ";";
  }
};
function mergeSelectors(selectors, { left = "", right = "" } = {}) {
  const output = selectors.reduce((selectors2, current) => {
    if (isPsuedoSelector(current)) {
      return selectors2 + current;
    }
    if (isImmediatePostcondition(current)) {
      return selectors2 + current.slice(1);
    }
    return joinTruthy([selectors2, current], " ");
  }, left);
  return joinTruthy([output, toClass(right)], " ");
}
var Selector = class _Selector {
  constructor(sheet, scopeName = null, {
    preconditions,
    postconditions,
    atRules
  } = {}) {
    this.sheet = sheet;
    this.preconditions = [];
    this.scopeClassName = null;
    this.scopeName = null;
    this.postconditions = [];
    this.atRules = [];
    this.preconditions = preconditions ? asArray(preconditions) : [];
    this.postconditions = postconditions ? asArray(postconditions) : [];
    this.atRules = atRules ? atRules.slice() : [];
    this.setScope(scopeName);
  }
  setScope(scopeName) {
    if (!scopeName) {
      return this;
    }
    if (!this.scopeClassName) {
      this.scopeName = scopeName;
      this.scopeClassName = stableHash(
        sheetIdent(this.sheet.name),
        // adding the count guarantees uniqueness across style.create calls
        scopeName + "\0" + this.sheet.count
      );
    }
    return this;
  }
  get hasConditions() {
    return this.preconditions.length > 0 || this.postconditions.length > 0;
  }
  addScope(scopeName) {
    return new _Selector(this.sheet, scopeName, {
      preconditions: this.preconditions,
      postconditions: this.postconditions,
      atRules: this.atRules
    });
  }
  addPrecondition(precondition) {
    return new _Selector(this.sheet, this.scopeClassName, {
      postconditions: this.postconditions,
      preconditions: this.preconditions.concat(precondition),
      atRules: this.atRules
    });
  }
  addPostcondition(postcondition) {
    return new _Selector(this.sheet, this.scopeClassName, {
      preconditions: this.preconditions,
      postconditions: this.postconditions.concat(postcondition),
      atRules: this.atRules
    });
  }
  addAtRule(atRule) {
    const selector = new _Selector(this.sheet, null, {
      preconditions: this.preconditions,
      postconditions: this.postconditions,
      atRules: this.atRules.concat(atRule)
    });
    selector.scopeClassName = this.scopeClassName;
    selector.scopeName = this.scopeName;
    return selector;
  }
  createRule(property, value) {
    return new Rule(this.sheet, property, value, this);
  }
};

// src/utils/forIn.ts
function forIn(obj, fn) {
  for (const key in obj) {
    fn(key.trim(), obj[key]);
  }
}

// src/keyframes.ts
function addKeyframes(sheet, input) {
  const keyframes = {};
  forIn(input, (name, stages) => {
    keyframes[name] = claimKeyframeName(sheet, name, stages);
  });
  return keyframes;
}
function claimKeyframeName(sheet, name, stages) {
  const seq = sheet.keyframeSeq();
  const hashed = formatKeyframeName(sheet.name, seq, name);
  const block = buildKeyframeBlock(hashed, stages);
  if (sheet.adoptedKeyframeBody(hashed) === stripWhitespace(block)) {
    return hashed;
  }
  return takeFreeKeyframeName(sheet, name, stages, seq);
}
function takeFreeKeyframeName(sheet, name, stages, start) {
  let counter = start;
  let hashed = formatKeyframeName(sheet.name, counter, name);
  while (sheet.isKeyframeNameTaken(hashed)) {
    counter += 1;
    hashed = formatKeyframeName(sheet.name, counter, name);
  }
  sheet.append(buildKeyframeBlock(hashed, stages));
  sheet.markKeyframeNameUsed(hashed);
  return hashed;
}
function formatKeyframeName(sheetName, counter, name) {
  return `${sheetIdent(sheetName)}_${counter}_${toCssIdent(name)}`;
}
function buildKeyframeBlock(hashed, stages) {
  let block = `@keyframes ${hashed} {`;
  forIn(stages, (stage, stylesObject) => {
    block = appendKeyframeStage(block, stage, stylesObject);
  });
  return `${block}
}`;
}
function appendKeyframeStage(block, stage, stylesObject) {
  let output = `${block}
${stage} {`;
  forIn(stylesObject, (key, value) => {
    if (isValidProperty(key, value)) {
      output = `${output} ${Rule.genRule(key, value)}`;
    }
  });
  return `${output} }`;
}
function stripWhitespace(value) {
  return value.replace(/\s+/g, "");
}

// src/classRegistry.ts
var classConflicts = /* @__PURE__ */ new Map();
function registerClassConflict(className, conflictKeys) {
  const existing = classConflicts.get(className);
  if (existing) {
    conflictKeys.forEach((key) => existing.add(key));
    return;
  }
  classConflicts.set(className, new Set(conflictKeys));
}
function getClassConflicts(className) {
  const found = classConflicts.get(className);
  return found ? Array.from(found) : void 0;
}

// src/Sheet.ts
var ruleLinePattern = /^\.([A-Za-z0-9_-]+)\s*\{\s*(.+?)\s*\}\s*$/;
var keyframesPattern = /^@keyframes\s+([A-Za-z0-9_-]+)\s*\{$/;
var Sheet = class {
  constructor(name, root) {
    this.name = name;
    // Hash->css
    this.storedStyles = {};
    // styles->hash
    this.storedClasses = {};
    this.adoptedTexts = /* @__PURE__ */ new Set();
    this.adoptedKeyframes = /* @__PURE__ */ new Map();
    this.usedKeyframeNames = /* @__PURE__ */ new Set();
    this.style = "";
    this.keyframesCount = 0;
    this.count = 0;
    this.id = `flairup-${name}`;
    const resolved = resolveSheetRoot(root);
    this.rootNode = resolved.rootNode;
    this.nonce = resolved.nonce;
    this.styleTag = this.createStyleTag();
  }
  getStyle() {
    return this.style;
  }
  append(css) {
    this.style = appendString(this.style, css);
  }
  appendInline(css) {
    this.style = appendStringInline(this.style, css);
  }
  seq() {
    return this.count++;
  }
  keyframeSeq() {
    return this.keyframesCount++;
  }
  getLength() {
    return this.style.length;
  }
  truncate(length) {
    this.style = this.style.slice(0, length);
  }
  apply() {
    this.seq();
    if (!this.styleTag) {
      return;
    }
    this.styleTag.innerHTML = this.style;
  }
  isApplied() {
    return !!this.styleTag;
  }
  isDetached() {
    return this.styleTag !== void 0 && !this.styleTag.isConnected;
  }
  getNonce() {
    return this.nonce;
  }
  setNonce(nonce) {
    this.nonce = nonce;
    if (this.styleTag && nonce) {
      this.styleTag.setAttribute("nonce", nonce);
    }
  }
  adoptedRuleText(text) {
    return this.adoptedTexts.has(text.trim());
  }
  adoptedKeyframeBody(name) {
    return this.adoptedKeyframes.get(name);
  }
  isKeyframeNameTaken(name) {
    return this.adoptedKeyframes.has(name) || this.usedKeyframeNames.has(name);
  }
  markKeyframeNameUsed(name) {
    this.usedKeyframeNames.add(name);
  }
  createStyleTag() {
    if (typeof document === "undefined" || this.isApplied() || // Explicitly disallow mounting to the DOM
    this.rootNode === null) {
      return this.styleTag;
    }
    return this.adoptStyleTag() ?? this.mountStyleTag();
  }
  addRule(rule) {
    const storedClass = this.storedClasses[rule.key];
    if (isString(storedClass)) {
      return storedClass;
    }
    const final = this.resolveHash(rule);
    this.commitRule(rule, final);
    return final;
  }
  resolveHash(rule) {
    let final = rule.hash;
    let counter = 0;
    while (this.isHashTaken(final, rule)) {
      counter += 1;
      final = `${rule.hash}_${counter}`;
    }
    return final;
  }
  isHashTaken(hash, rule) {
    const stored = this.storedStyles[hash];
    return stored !== void 0 && (stored[0] !== rule.property || stored[1] !== rule.value);
  }
  commitRule(rule, hash) {
    rule.hash = hash;
    this.storedClasses[rule.key] = hash;
    this.storedStyles[hash] = [rule.property, rule.value];
    registerClassConflict(hash, rule.getConflictKeys());
    this.appendUnlessAdopted(rule);
  }
  appendUnlessAdopted(rule) {
    const text = rule.toString();
    if (!this.adoptedTexts.has(text.trim())) {
      this.append(text);
    }
  }
  adoptStyleTag() {
    const existing = this.findExistingStyleTag();
    if (!existing) {
      return void 0;
    }
    const css = existing.innerHTML;
    this.style = css;
    this.applyNonce(existing);
    this.hydrateFromStyle(css);
    return existing;
  }
  hydrateFromStyle(css) {
    const lines = css.split("\n");
    const stack = [];
    let index = 0;
    while (index < lines.length) {
      const line = lines[index];
      if (line === void 0) {
        break;
      }
      index = this.hydrateLine(lines, line.trim(), stack, index);
    }
  }
  hydrateLine(lines, line, stack, index) {
    if (isKeyframes(line) && keyframesPattern.test(line)) {
      return this.adoptKeyframesBlock(lines, index);
    }
    if (!this.trackStructure(line, stack)) {
      this.adoptRuleLine(line, stack.join("|"));
    }
    return index + 1;
  }
  trackStructure(line, stack) {
    if (isMediaOpener(line)) {
      stack.push(mediaOpenerText(line));
      return true;
    }
    if (line === "}") {
      stack.pop();
      return true;
    }
    return false;
  }
  adoptRuleLine(line, atKey) {
    if (!line) {
      return;
    }
    this.adoptedTexts.add(line);
    const parsed = parseAdoptedRule(line, this.name);
    if (parsed) {
      this.storeAdoptedRule(parsed, atKey);
    }
  }
  storeAdoptedRule(rule, atKey) {
    const joined = `${rule.prop}:${rule.value}`;
    this.storedClasses[[joined, "", atKey, ""].join("\0")] = rule.hash;
    this.storedStyles[rule.hash] = [rule.prop, rule.value];
    registerClassConflict(
      rule.hash,
      coveredProperties(rule.prop).map((prop) => conflictKey(prop, atKey))
    );
  }
  adoptKeyframesBlock(lines, index) {
    const end = findBlockEnd(lines, index);
    if (end < 0) {
      return index + 1;
    }
    const opener = lines[index];
    const name = opener === void 0 ? "" : parseKeyframeName(opener.trim());
    if (name) {
      this.adoptedKeyframes.set(
        name,
        stripWhitespace2(lines.slice(index, end + 1).join("\n"))
      );
    }
    return end + 1;
  }
  mountStyleTag() {
    const styleTag = document.createElement("style");
    styleTag.type = "text/css";
    styleTag.id = this.id;
    this.applyNonce(styleTag);
    this.getMountTarget().appendChild(styleTag);
    return styleTag;
  }
  getMountTarget() {
    return this.rootNode ?? document.head;
  }
  findExistingStyleTag() {
    const scope = this.rootNode ?? document;
    const lookup = scope;
    if (typeof lookup.getElementsByTagName === "function") {
      return this.findTagById(lookup.getElementsByTagName("style"));
    }
    return findStyleTagById(scope, this.id);
  }
  findTagById(tags) {
    for (let i = 0; i < tags.length; i++) {
      const tag = tags[i];
      if (tag && tag.id === this.id && tag.tagName === "STYLE") {
        return tag;
      }
    }
    return void 0;
  }
  applyNonce(styleTag) {
    if (!this.nonce) {
      return;
    }
    styleTag.setAttribute("nonce", this.nonce);
  }
};
function resolveSheetRoot(root) {
  if (!root || isRootNode(root)) {
    return { rootNode: root, nonce: void 0 };
  }
  return { rootNode: root.rootNode, nonce: root.nonce };
}
function isRootNode(value) {
  return typeof value.nodeType === "number";
}
function isMediaOpener(line) {
  return line.endsWith("{") && isMediaQuery(mediaOpenerText(line));
}
function mediaOpenerText(line) {
  return line.slice(0, -1).trim();
}
function conflictKey(prop, atKey) {
  return [prop, "", "", atKey].join("\0");
}
function stripWhitespace2(value) {
  return value.replace(/\s+/g, "");
}
function findBlockEnd(lines, start) {
  for (let i = start + 1; i < lines.length; i++) {
    if (lines[i]?.trim() === "}") {
      return i;
    }
  }
  return -1;
}
function parseKeyframeName(opener) {
  const match = keyframesPattern.exec(opener);
  return match?.[1] ?? "";
}
function parseAdoptedRule(line, sheetName) {
  const match = ruleLinePattern.exec(line);
  const hash = match?.[1];
  const body = match?.[2];
  if (!hash || !body || !isSheetHash(hash, sheetName)) {
    return void 0;
  }
  const declaration = splitDeclaration(body);
  if (!declaration) {
    return void 0;
  }
  return { hash, prop: declaration[0], value: declaration[1] };
}
function isSheetHash(hash, sheetName) {
  return hash.startsWith(`${sheetIdent(sheetName)}_`);
}
function splitDeclaration(body) {
  const parts = body.split(";").map((part) => part.trim()).filter((part) => part !== "");
  const only = parts[0];
  if (parts.length !== 1 || !only) {
    return void 0;
  }
  const separator = only.indexOf(":");
  if (separator < 0) {
    return void 0;
  }
  return [only.slice(0, separator).trim(), only.slice(separator + 1).trim()];
}
function findStyleTagById(node, id) {
  const children = node.childNodes;
  for (let i = 0; i < children.length; i++) {
    const found = findStyleTagInChild(children[i], id);
    if (found) {
      return found;
    }
  }
  return void 0;
}
function findStyleTagInChild(child, id) {
  if (!child) {
    return void 0;
  }
  const element = child;
  if (element.tagName === "STYLE" && element.id === id) {
    return element;
  }
  return findStyleTagById(child, id);
}

// src/cx.ts
function cx(...args) {
  const tokens = [];
  flattenCxArgs(args, tokens);
  return resolveCxConflicts(tokens);
}
function flattenCxArgs(args, tokens) {
  args.forEach((arg) => pushCxArg(arg, tokens));
}
function pushCxArg(arg, tokens) {
  if (typeof arg === "string") {
    splitCxToken(arg, tokens);
    return;
  }
  if (arg && typeof arg === "object") {
    pushCxComposite(arg, tokens);
  }
}
function pushCxComposite(arg, tokens) {
  if (arg instanceof Set) {
    arg.forEach((value) => pushCxArg(value, tokens));
    return;
  }
  if (Array.isArray(arg)) {
    flattenCxArgs(arg, tokens);
    return;
  }
  pushCxObject(arg, tokens);
}
function pushCxObject(arg, tokens) {
  Object.entries(arg).forEach(([key, value]) => {
    if (value) {
      splitCxToken(key, tokens);
    }
  });
}
function splitCxToken(token, tokens) {
  token.split(/\s+/).forEach((part) => {
    if (part) {
      tokens.push(part);
    }
  });
}
function resolveCxConflicts(tokens) {
  const claimed = /* @__PURE__ */ new Set();
  const keep = tokens.map(() => false);
  claimCxTokens(tokens, keep, claimed);
  return tokens.filter((_, index) => keep[index]).join(" ");
}
function claimCxTokens(tokens, keep, claimed) {
  for (let index = tokens.length - 1; index >= 0; index--) {
    claimCxToken(tokens, keep, claimed, index);
  }
}
function claimCxToken(tokens, keep, claimed, index) {
  const token = tokens[index];
  const keys = getClassConflicts(token) ?? [token];
  if (keys.some((key) => claimed.has(key))) {
    return;
  }
  keep[index] = true;
  keys.forEach((key) => claimed.add(key));
}

// src/treeParseUtils.ts
function iterateTopLevel(sheet, styles, selector) {
  const output = {
    preconditions: []
  };
  forIn(styles, (key, value) => {
    if (isStyleCondition(key)) {
      const res = iterateTopLevel(
        sheet,
        value,
        selector.addPrecondition(key)
      );
      res.preconditions.forEach((item) => output.preconditions.push(item));
      return output;
    }
    output.preconditions.push([key, styles[key], selector.addScope(key)]);
    return output;
  });
  return output;
}
function iterateStyles(sheet, styles, selector) {
  const output = /* @__PURE__ */ new Set();
  forIn(styles, (property, value) => {
    let res = [];
    if (isStyleCondition(property)) {
      res = iterateStyles(
        sheet,
        value,
        selector.addPostcondition(property)
      );
    } else if (isDirectClass(property)) {
      res = asArray(value);
    } else if (isMediaQuery(property)) {
      res = handleMediaQuery(sheet, value, property, selector);
    } else if (isCssVariables(property)) {
      res = cssVariablesBlock(sheet, value, selector);
    } else if (isValidProperty(property, value)) {
      createDeclarationRules(selector, property, value).forEach((rule) => {
        sheet.addRule(rule);
        output.add(rule.hash);
      });
    }
    return addEachClass(res, output);
  });
  return output;
}
function addEachClass(list, to) {
  list.forEach((className) => to.add(className));
  return to;
}
function createDeclarationRules(selector, property, value) {
  const expanded = expandShorthand(property, value);
  if (!expanded) {
    return [selector.createRule(property, value)];
  }
  return expanded.map(
    ([longhand, token]) => selector.createRule(longhand, token)
  );
}
function expandShorthand(property, value) {
  const prepared = prepareShorthand(property, value);
  if (!prepared) {
    return void 0;
  }
  return expandPrepared(prepared);
}
function prepareShorthand(property, value) {
  const expansion = distributiveExpansion(camelCaseToDash(property));
  if (!expansion) {
    return void 0;
  }
  return expandTokens(expansion, String(value));
}
function expandTokens(expansion, value) {
  const { text, important } = splitImportant(value);
  const { tokens, slash } = tokenizeValue(text);
  if (tokens.length === 0 || tokens.some(isOpaqueValue)) {
    return void 0;
  }
  return {
    kind: expansion.kind,
    longhands: expansion.longhands,
    tokens,
    slash,
    important,
    text
  };
}
function expandPrepared(prepared) {
  const { kind, slash, tokens } = prepared;
  if (kind === "corners" && slash) {
    return expandElliptical(prepared);
  }
  if (tokens.length === 1) {
    return expandSingle(prepared);
  }
  return expandPositional(prepared);
}
function expansionTargets(prepared) {
  return prepared.kind === "box" ? prepared.longhands.slice(0, 4) : prepared.longhands;
}
function expandSingle(prepared) {
  const { tokens, important } = prepared;
  const only = tokens[0];
  if (!only) {
    return void 0;
  }
  return expansionTargets(prepared).map((longhand) => [
    longhand,
    withImportant(only, important)
  ]);
}
var quadSides = {
  1: [0, 0, 0, 0],
  2: [0, 1, 0, 1],
  3: [0, 1, 2, 1],
  4: [0, 1, 2, 3]
};
var pairSides = {
  2: [0, 1]
};
function expandPositional(prepared) {
  const { kind, tokens, slash, important } = prepared;
  if (slash) {
    return void 0;
  }
  const sides = kind === "pair" ? pairSides[tokens.length] : quadSides[tokens.length];
  if (!sides) {
    return void 0;
  }
  return assignPositional(expansionTargets(prepared), sides, tokens, important);
}
function expandElliptical(prepared) {
  const halves = splitElliptical(prepared.text);
  if (!halves) {
    return void 0;
  }
  const horizontal = quadAssign(tokenizeValue(halves.horizontal).tokens);
  const vertical = quadAssign(tokenizeValue(halves.vertical).tokens);
  if (!horizontal || !vertical) {
    return void 0;
  }
  return assignCorners(prepared, horizontal, vertical);
}
function splitElliptical(text) {
  const slashAt = topLevelSlash(text);
  if (slashAt < 0) {
    return void 0;
  }
  const horizontal = text.slice(0, slashAt).trim();
  const vertical = text.slice(slashAt + 1).trim();
  if (!horizontal || !vertical || topLevelSlash(vertical) >= 0) {
    return void 0;
  }
  return { horizontal, vertical };
}
function topLevelSlash(text) {
  let depth = 0;
  for (let index = 0; index < text.length; index++) {
    const char = text[index];
    depth = Math.max(0, depth + parenDelta(char));
    if (depth === 0 && char === "/") {
      return index;
    }
  }
  return -1;
}
function quadAssign(tokens) {
  const sides = quadSides[tokens.length];
  if (!sides) {
    return void 0;
  }
  return assignTokens(tokens, sides);
}
function assignTokens(tokens, sides) {
  const output = [];
  for (const side of sides) {
    const token = tokens[side];
    if (token === void 0) {
      return void 0;
    }
    output.push(token);
  }
  return output;
}
function assignCorners(prepared, horizontal, vertical) {
  const output = [];
  prepared.longhands.forEach((longhand, index) => {
    const across = horizontal[index];
    const down = vertical[index];
    if (across === void 0 || down === void 0) {
      return;
    }
    output.push([
      longhand,
      withImportant(`${across} ${down}`, prepared.important)
    ]);
  });
  return output;
}
function assignPositional(positional, sides, tokens, important) {
  const output = [];
  sides.forEach((tokenIndex, index) => {
    const longhand = positional[index];
    const token = tokens[tokenIndex];
    if (longhand !== void 0 && token !== void 0) {
      output.push([longhand, withImportant(token, important)]);
    }
  });
  return output;
}
function withImportant(token, important) {
  return important ? `${token} !important` : token;
}
function splitImportant(text) {
  const match = /^(.*?)\s*!important\s*$/i.exec(text);
  if (!match) {
    return { text, important: false };
  }
  return { text: (match[1] ?? "").trim(), important: true };
}
function isOpaqueValue(text) {
  const trimmed = text.trim();
  const open = /^(var|env|attr)\(/i.exec(trimmed);
  if (!open) {
    return false;
  }
  return closesAtEnd(trimmed, open[0].length - 1);
}
function closesAtEnd(trimmed, start) {
  let depth = 0;
  for (let index = start; index < trimmed.length; index++) {
    depth = Math.max(0, depth + parenDelta(trimmed[index]));
    if (depth === 0) {
      return index === trimmed.length - 1;
    }
  }
  return true;
}
function parenDelta(char) {
  if (char === "(") {
    return 1;
  }
  if (char === ")") {
    return -1;
  }
  return 0;
}
function tokenizeValue(text) {
  const tokens = [];
  const state = { current: "", depth: 0, slash: false };
  for (const char of text) {
    stepTokenChar(state, char, tokens);
  }
  pushToken(tokens, state);
  return { tokens, slash: state.slash };
}
function stepTokenChar(state, char, tokens) {
  state.depth = Math.max(0, state.depth + parenDelta(char));
  if (state.depth === 0 && isWhitespace(char)) {
    pushToken(tokens, state);
    return;
  }
  if (state.depth === 0 && char === "/") {
    state.slash = true;
  }
  state.current += char;
}
function pushToken(tokens, state) {
  if (state.current) {
    tokens.push(state.current);
    state.current = "";
  }
}
function isWhitespace(char) {
  return char === " " || char === "	" || char === "\n" || char === "\r";
}
function cssVariablesBlock(sheet, styles, selector) {
  const classes = /* @__PURE__ */ new Set();
  const chunkRows = [];
  const scope = selector.scopeClassName;
  forIn(styles, (property, value) => {
    if (isValidProperty(property, value)) {
      if (scope) {
        const rule = selector.createRule(property, value);
        classes.add(sheet.addRule(rule));
        return;
      }
      chunkRows.push(Rule.genRule(property, value));
      return;
    }
    const res = iterateStyles(sheet, value ?? {}, selector);
    addEachClass(res, classes);
  });
  if (!scope && chunkRows.length) {
    appendAmbientVariables(sheet, chunkRows.join(" "), selector);
  }
  return classes;
}
function appendAmbientVariables(sheet, css, selector) {
  let selectors = mergeSelectors(selector.preconditions, {});
  selectors = mergeSelectors(selector.postconditions, {
    left: selectors
  });
  if (selectors) {
    sheet.append(`${selectors} {${css}}`);
  }
}
function handleMediaQuery(sheet, styles, mediaQuery, selector) {
  const mark = sheet.getLength();
  sheet.append(mediaQuery + " {");
  const innerMark = sheet.getLength();
  const output = iterateStyles(sheet, styles, selector.addAtRule(mediaQuery));
  if (sheet.getLength() === innerMark) {
    sheet.truncate(mark);
    return output;
  }
  sheet.append("}");
  return output;
}

// src/index.ts
function createSheet(name, rootNode) {
  const sheet = resolveSheet(name, rootNode);
  return {
    create: genCreate(sheet),
    keyframes: genKeyframes(sheet),
    getStyle: sheet.getStyle.bind(sheet),
    isApplied: sheet.isApplied.bind(sheet)
  };
}
var defaultSheets = /* @__PURE__ */ new Map();
var rootedSheets = /* @__PURE__ */ new WeakMap();
function resolveSheet(name, root) {
  const resolved = resolveSheetRoot(root);
  if (!isCacheableContext(resolved.rootNode)) {
    return new Sheet(name, root);
  }
  return reuseOrCreateSheet(name, root, resolved.rootNode, resolved.nonce);
}
function reuseOrCreateSheet(name, root, rootNode, nonce) {
  const cacheKey = normalizeCacheRoot(rootNode);
  const cached = findCachedSheet(name, cacheKey);
  if (cached && !cached.isDetached()) {
    syncNonce(cached, nonce);
    return cached;
  }
  const sheet = new Sheet(name, root);
  storeCachedSheet(name, cacheKey, sheet);
  return sheet;
}
function normalizeCacheRoot(rootNode) {
  if (rootNode === void 0 && typeof document !== "undefined") {
    return document.head;
  }
  return rootNode;
}
function isCacheableContext(rootNode) {
  return typeof document !== "undefined" && rootNode !== null;
}
function findCachedSheet(name, rootNode) {
  if (rootNode === void 0) {
    return defaultSheets.get(name);
  }
  const scoped = rootedSheets.get(rootNode);
  return scoped?.get(name);
}
function storeCachedSheet(name, rootNode, sheet) {
  if (rootNode === void 0) {
    defaultSheets.set(name, sheet);
    return;
  }
  storeRootedSheet(rootNode, name, sheet);
}
function storeRootedSheet(rootNode, name, sheet) {
  let scoped = rootedSheets.get(rootNode);
  if (!scoped) {
    scoped = /* @__PURE__ */ new Map();
    rootedSheets.set(rootNode, scoped);
  }
  scoped.set(name, sheet);
}
function syncNonce(sheet, nonce) {
  if (nonce !== void 0 && nonce !== sheet.getNonce()) {
    sheet.setNonce(nonce);
  }
}
function genCreate(sheet) {
  return function create(styles) {
    const scopedStyles = {};
    const topLevel = iterateTopLevel(sheet, styles, new Selector(sheet));
    topLevel.preconditions.forEach(([scopeName, styles2, selector]) => {
      iterateStyles(sheet, styles2, selector).forEach((className) => {
        addScopedStyle(scopeName, className);
      });
    });
    sheet.apply();
    return scopedStyles;
    function addScopedStyle(name, className) {
      scopedStyles[name] = scopedStyles[name] ?? /* @__PURE__ */ new Set();
      scopedStyles[name].add(className);
    }
  };
}
function genKeyframes(sheet) {
  return function keyframes(keyframesInput) {
    const output = addKeyframes(sheet, keyframesInput);
    sheet.apply();
    return output;
  };
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  createSheet,
  cx
});
